// extracted by mini-css-extract-plugin
export var header = "header-module--header--1O26W";
export var logo = "header-module--logo--3DCRu";
export var name = "header-module--name--3DAB0";
export var contact = "header-module--contact--2ECVj";
export var base = "header-module--base--3D5ZN";
export var menu = "header-module--menu--19ye7";
export var dimmer = "header-module--dimmer--3FrBN";